app.controller('BrowseCustomTallstorDrawerController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    const siteHelper = $rootScope.site_helper;

    let product = $scope.product = null;
    const componentNavigationIDs = $rootScope.navigation_manager.getStateIDs(-1, "component");

    let colourVariationIDs = null;
    const styleVariationIDs = siteHelper.simpleCloneObject(componentNavigationIDs);
    styleVariationIDs.custom_id = "tallstor_drawer"

    $scope.colour_model = null;
    $scope.style_model = null;
    $scope.tallstor_temporarily_disabled = false;

    $scope.applyProduct = function (partialProduct) {
        product = $scope.product = partialProduct;
    }


    $scope.changeTallstorMatch = function () {

        const siteRangeID = componentNavigationIDs.site_range_id;
        const requestRangeID = $rootScope.service.site_range.getRequestRangeID(siteRangeID)

        product.inner_colour_id = null;
        product.inner_style_id = null;
        product.inner_drawer_request_range_id = requestRangeID;

        colourVariationIDs = siteHelper.simpleCloneObject(componentNavigationIDs);

        if (product.tallstor_match_id !== "kitchen_door") {
            if (product.tallstor_match_id === "cabinet") {
                product.inner_drawer_request_range_id = "valore";
                colourVariationIDs.site_range_id = "valore";
                colourVariationIDs.custom_id = "tallstor_cabinet";
            } else if (product.tallstor_match_id === "drawer_box") {
                colourVariationIDs.custom_id = "tallstor_drawer_box";
            }
            if (siteRangeID === "bella") {
                product.inner_style_id = "venice";
            }
        }

        $scope.colour_model = $rootScope.factory.colour.getModel(colourVariationIDs);
        $scope.colour_model.apiRequire();
        if (product.tallstor_match_id === "kitchen_door" && siteRangeID === "bella") {
            $scope.style_model = $rootScope.factory.style.getModel(styleVariationIDs);
            $scope.style_model.apiRequire();
        } else {
            $scope.style_model = null;
        }
    }

    $scope.canShowColour = function () {
        return !!product.tallstor_match_id;
    }

    $scope.canShowStyle = function () {
        return componentNavigationIDs.site_range_id === "bella" && product.tallstor_match_id === 'kitchen_door';
    }

    $scope.getStyleImgSrc = function () {
        if (!product.inner_style_id) {
            return null;
        }
        const navigationIDs = componentNavigationIDs;
        const colourID = product.inner_colour_id ? product.inner_colour_id : navigationIDs.colour_id;
        return $rootScope.service.image.getStyleImgSrc(navigationIDs.site_range_id, colourID, product.inner_style_id);
    }

    $scope.colourProduct = function () {
        if (!product.inner_colour_id || !$scope.colour_model) {
            return null;
        }
        return $scope.colour_model.choices[product.inner_colour_id];
    }

    $scope.styleProduct = function () {
        if (!product.inner_style_id || !$scope.style_model) {
            return null;
        }
        return $scope.style_model.choices[product.inner_style_id];
    }


    $scope.openInnerColourSelect = function () {

        const customVariationIDs = JSON.parse(JSON.stringify(colourVariationIDs));
        const styleProduct = $scope.styleProduct();
        const colourExceptions = styleProduct ? styleProduct.colour_exceptions : null;


        const colourModel = $rootScope.factory.colour.getModel(customVariationIDs);
        $scope.tallstor_temporarily_disabled = true;

        colourModel.apiRequire(function () {
            $scope.tallstor_temporarily_disabled = false;
            const fromChoiceList = $scope.colour_model.choiceList();
            let choiceList;
            if (!colourExceptions) {
                choiceList = fromChoiceList;
            } else {
                choiceList = [];
                for (let i = 0; i < fromChoiceList.length; i++) {
                    const choice = fromChoiceList[i];
                    if (!colourExceptions[choice.id]) {
                        choiceList.push(choice);
                    }
                }
            }

            $bootstrapModal.open({
                templateUrl: 'BrowseCommonModalColour.html',
                controller: 'CommonModalSimpleController',
                //size: 'lg',
                resolve: {
                    items: {
                        title: "Select a Drawer Colour",
                        params: {
                            current_colour_id: product.inner_colour_id,
                        },
                        choice_list: choiceList,
                        callback: function (params) {
                            product.inner_colour_id = params.current_colour_id;
                        }
                    }
                }
            });

        });
    }

    $scope.openInnerStyleSelect = function () {

        const customVariationIDs = JSON.parse(JSON.stringify(styleVariationIDs));
        const colourProduct = $scope.colourProduct();
        const currentColourID = colourProduct ? colourProduct.id : null;

        const styleModel = $rootScope.factory.style.getModel(customVariationIDs);
        $scope.tallstor_temporarily_disabled = true;

        styleModel.apiRequire(function () {
            $scope.tallstor_temporarily_disabled = false;
            const fromChoiceList = $scope.style_model.choiceList();
            let choiceList;
            if (!currentColourID) {
                choiceList = fromChoiceList;
            } else {
                choiceList = [];
                for (let i = 0; i < fromChoiceList.length; i++) {
                    const choice = fromChoiceList[i];
                    if (!choice.colour_exceptions[currentColourID]) {
                        choiceList.push(choice);
                    }
                }
            }

            $bootstrapModal.open({
                templateUrl: 'BrowseCommonModalStyle.html',
                controller: 'CommonModalSimpleController',
                //size: 'lg',
                resolve: {
                    items: {
                        title: "Select a Drawer Style",
                        params: {
                            current_style_id: product.inner_style_id,
                        },
                        choice_list: choiceList,
                        getStyleImgSrc: function (styleID) {
                            const navigationIDs = componentNavigationIDs;
                            const colourID = currentColourID ? currentColourID : navigationIDs.colour_id;
                            return $rootScope.service.image.getStyleImgSrc(navigationIDs.site_range_id, colourID, styleID);
                        },
                        callback: function (params) {
                            product.inner_style_id = params.current_style_id;
                        }
                    }
                }
            });

        });
    }

}]);